module.exports = __webpack_public_path__ + "media/images/icons/outlined/medium-workmark-5c3875ef42cf086e3f77c883451fdd68.svg";